<template>
  <v-autocomplete 
    v-model="vModel"
    :loading="isLoading" 
    :search-input.sync="searchText" 
    :items="searchItems"
    :label="placeholder" 
    :hide-no-data="hideNoData" 
    :class="customClass" 
    :clearable="clearable"
    :item-text="searchBy" 
    :item-value="searchValue"
    :readonly="isReadonly"
    :disabled="isDisabled"
    :multiple="multiple"
    :rules="rules"
  >
    <template slot="item" slot-scope="data">
      <v-list-tile-content>
        <v-list-tile-title v-text="data.item[searchBy]"></v-list-tile-title>
        <v-list-tile-sub-title v-if="data.item[titleSub]" class="caption" v-text="data.item[titleSub]"></v-list-tile-sub-title>
      </v-list-tile-content>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    clearable: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    hideNoData: {
      type: Boolean,
      default: true
    },
    customClass: {
      type: String,
      default: "mr-3"
    },
    searchKey: {
      type: String,
      default: 'title'
    },
    searchValue: {
      type: String,
      default: 'id'
    },
    subTitle: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default () {
        return []
      }
    },
    apiPath:{
      type: String,
      default: ''
    },
    value: null,
    customParams: {
      type: Object,
      default () {
        return {}
      }
    },
    static: {
      type: Boolean,
      default: false
    },

    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default () {
        return []
      }
    },
    async: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      isLoading: false,
      searchText: '',
      placeholder: this.label,
      searchBy: this.searchKey,
      titleSub: this.subTitle,
      searchItems: this.items,
      vModel: this.value,
      isStatic: this.static,
      isReadonly: this.readonly,
      isDisabled: this.disabled,
      isAsync: this.async
    }
  },
  
  methods: {

  	searchData () {
      
      let customParams = Object.entries(this.customParams)
      let params = []

      if (this.searchText) {
        params.push(`${this.searchBy}=${this.searchText}`)
      }

      if (customParams.length) {
        for(const [key, val] of customParams){
          if (val) {
            params.push(`${key}=${val}`)
          }
        }
      }

      let path = this.apiPath + (params.length ? '?' + params.join('&') : '')
      
      this.isLoading = true
      
      this.axios.get(path)
        .then( response => {
          if (this.isSuccessResponse(response)) {
            this.searchItems = response.data.data
          }
        })
        .catch(error => {
            
        })
        .then(() => {
          this.isLoading = false
        })
    },

  },

  watch: {
  	
    searchText (val) {
      let current = this.searchItems.filter(item => item[this.searchValue] === this.vModel)
      let exist = current.length && current[0][this.searchBy] === val
      if (val && !exist && !this.isStatic && this.isAsync) {
        this.searchData()
      }
  	},

    items (val) {
      if(!this.isAsync && val){
        this.searchItems = val
      }
    },

    vModel (val) {
      if (typeof val === typeof undefined) {
        this.vModel = ''
      }
      else if(val !== this.value) {
        this.$emit('change', val)

        if (val) {
          let current = this.searchItems.filter(item => item[this.searchValue] === val)
          if (current.length) {
            this.$emit('selected', current[0])
          }
        }
        
      }
    },

    value (val) {
      // if (val) {
        this.vModel = val
      // }
    },

  },

  created () {
    if(!this.isAsync){
      if (this.apiPath) {
        this.searchData()
      }
      else if(!this.searchItems.length){
        new Error("items or api path should be provided for autocomplete!")
      }
    }
    else if(!this.apiPath){
      new Error("api path should not be empty for async autocomplete!")
    }
  }
}
</script>
